export const legacyTransform = (rawData): Content.ComparisonFilterTableProps['content']['properties']['data']['children'] => {
	// Transform columns
	const columns: Content.ComparisonFilterTableColumns = {
		documentType: 'columns',
		name: 'Table header',
		properties: {
			tableLabel: rawData?.find((item) => item.contentType === 'columns')?.properties?.tableLabel || '',
		},
		children: rawData
			.filter((item) => item.contentType === 'columnLabel')
			.map((item) => ({
				documentType: 'columnLabel',
				name: item.name,
			})),
	};

	// Transform data
	const data: Content.ComparisonFilterTableData = {
		documentType: 'data',
		children: rawData
			.filter((item) => item.contentType === 'comparisonTableGroup') // Filter for relevant content
			.map((parent) => {
				return {
					name: parent.name,
					documentType: 'comparisonTableGroup',
					children: rawData
						.filter((child) => child.contentType === 'comparisonTableItems')
						.filter((child) => {
							const parentGroup = child.route.path.split('/').slice(-2, -1)[0];
							if (parentGroup.toLowerCase() === parent.name.toLowerCase()) return true;
							return false;
						})
						.map((child) => {
							const items: Content.ComparisonFilterTableItem[] = child.properties.tableItems.items.map((item) => {
								return {
									content: {
										properties: {
											columnReference: item.content.properties.columnReference[0],
											value: item.content.properties.value,
										},
									},
								};
							});
							return {
								name: child.name,
								documentType: 'comparisonTableItems',
								properties: {
									tableItems: {
										items: items,
									},
								},
							};
						}),
				};
			}),
	};

	// Transform filters
	const searchFilter = rawData.find((item) => item.contentType === 'comparisonFilterSearch');
	const filters: Content.ComparisonFilterTableFilters = {
		documentType: 'comparisonFilters',
		id: rawData.find((item) => item.contentType === 'comparisonFilters').id,
		children: rawData
			.filter((item) => item.contentType === 'comparisonFilterSetting')
			.map((filterSetting) => {
				return {
					documentType: 'comparisonFilterSetting',
					properties: {
						filterType: filterSetting?.properties?.filterType ?? 'Custom',
						label: filterSetting?.properties?.label || '',
						reference: filterSetting?.properties?.reference?.[0] ?? null,
						filters:
							filterSetting?.properties?.filters?.items?.map((subItem) => ({
								content: {
									properties: {
										label: subItem.content?.properties?.label ?? '',
										valueType: subItem.content?.properties?.valueType ?? '',
										value: subItem.content?.properties?.value ?? '',
									},
								},
							})) || [],
					},
				};
			})
			.concat(searchFilter ? { documentType: 'comparisonFilterSearch', ...searchFilter } : null),
	};

	// Return the array of children directly
	return [columns, data, filters];
};
